import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Client from '../utils/network';
import { setAuth } from '../reducers/auth/authReducerActions';

export default function Redirect (): JSX.Element {
    const navigate = useNavigate();
    const dispatch  = useDispatch();
    const [searchParams] = useSearchParams();
    const [hasRequested, setHasRequested] = useState(false);

    useEffect(() => {
        if (!hasRequested && searchParams.get('code') !== undefined) {
            setHasRequested(true);
            Client.request(`/api/login-old?code=${searchParams.get('code') as string}`
                +`&redirect_uri=${encodeURIComponent(`${window.location.origin}/redirect`)}`).then((response) => {
                if(response.status > 299) {
                    dispatch(setAuth(false));
                    navigate('/');
                    return;
                }
                dispatch(setAuth(true));
                navigate('/main');
                return;
            }).catch(() => {
                dispatch(setAuth(false));
                navigate('/');
            });
        } else {
            dispatch(setAuth(false));
            navigate('/');
        }
    }, [searchParams, navigate]);
    return (
        <div>Redirect</div>
    );
}
